export default __webpack_public_path__ + "static/media/alan_powered.c6b8686d.png";